import { Loader2, AlertTriangle, ThumbsUp } from "lucide-react";
import { useTaal } from "@/contexts/TaalContext";

/**
 * What the council has managed so far, while it is still running. A council
 * waits on several models plus a judge, and a blank screen for that long reads
 * as a hang. The badge and the full detail replace this once the verdict lands.
 *
 * Its own file rather than a helper inside MessageBubble, because MessageBubble
 * pulls in react-markdown, which the pinned Jest cannot parse. This has to stay
 * testable.
 */
export default function CouncilProgress({ members = [] }) {
  const { t } = useTaal();
  if (members.length === 0) return null;

  return (
    <div className="mb-2 space-y-1" data-testid="council-progress">
      <div className="flex items-center gap-1.5 text-[10px] font-medium text-muted-foreground">
        <Loader2 className="h-3 w-3 animate-spin" />
        {members.length === 1
          ? t("Raad in zitting, 1 lid heeft geantwoord")
          : t("Raad in zitting, {n} leden hebben geantwoord", { n: members.length })}
      </div>
      {members.map((m, i) => (
        <div key={i} className="flex items-center gap-2 pl-4 text-[11px]">
          {m.error ? (
            <AlertTriangle className="h-3 w-3 text-corona flex-shrink-0" />
          ) : (
            <ThumbsUp className="h-3 w-3 text-ok flex-shrink-0" />
          )}
          <span className="font-medium">
            {m.provider} / {m.model}
          </span>
          {typeof m.duration_ms === "number" && (
            <span className="text-muted-foreground">{(m.duration_ms / 1000).toFixed(1)}s</span>
          )}
          {/* A member that failed still counts as reported. Leaving it out
              would make the council look smaller than it was. */}
          {m.error && <span className="text-corona">{t("geen antwoord")}</span>}
        </div>
      ))}
    </div>
  );
}
